/**
 * Mega Menu
 */

// Vendors
import $ from 'jquery';
let showTimeout = 0;
let showTimeout2 = 0;
let leaveTimeout = 0;
let leaveTimeout2 = 0;
let enterY = 0;
let leaveY = 0;

$('.mega-menu__show')
  .on('mouseenter', (event) => {
    const menu = $(event.target).data('mega-menu-show');
    const toggle = $(event.target);
    enterY = event.pageY;

    // Check enter and leave pageY positions and if the user hover above and
    // back in the nav item we want to clear the leaveTimeout timeout.
    if (
      enterY <= 60 &&
      leaveY <= 51 &&
      enterY !== leaveY &&
      toggle.hasClass('related-mega-menu-visible')
    ) {
      clearTimeout(leaveTimeout);
      clearTimeout(leaveTimeout2);
    }
    // Set timeout to add delay when showing megamenu
    showTimeout = setTimeout(function () {
      showMegaMenu(menu, toggle);
    }, 200);
  })
  .on('mouseleave', (event) => {
    // clear showTimeout timeout on mouse leave to not trigger the
    // showMegaMenu() function
    clearTimeout(showTimeout);
    clearTimeout(showTimeout2);
    leaveY = event.pageY;
    // Set timeout to add delay when hidding megamenu
    leaveTimeout = setTimeout(function () {
      hideMegaMenu();
    }, 200);
  });

$('.mega-menu')
  .on('mouseenter', (event) => {
    const menu = $(event.target).data('mega-menu');
    const toggle = $(`[data-mega-menu-show="${menu}"]`);
    // Clear both leave timeouts when mouse has entered the megamenu so the menu
    // will always stay open whe mouse has entered.
    clearTimeout(leaveTimeout);
    clearTimeout(leaveTimeout2);
    showTimeout2 = setTimeout(function () {
      showMegaMenu(menu, toggle);
    }, 200);
  })
  .on('mouseleave', (event) => {
    clearTimeout(showTimeout);
    clearTimeout(showTimeout2);
    leaveTimeout2 = setTimeout(function () {
      hideMegaMenu();
    }, 200);
  });

$(window).on('scroll', () => hideMegaMenu());

function showMegaMenu(menu, toggle) {
  $(`[data-mega-menu="${menu}"]`).addClass('mega-menu--visible');
  toggle.addClass('related-mega-menu-visible');
  $('body').addClass('mega-menu-is-visible');
}

function hideMegaMenu() {
  $('.mega-menu').removeClass('mega-menu--visible');
  $('[data-mega-menu-show]').removeClass('related-mega-menu-visible');
  $('body').removeClass('mega-menu-is-visible');
}
